import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.myTeam;

export default {
  getBelowMember: (params) => http.post(api.search, params),
  getMemberInfo: (params) => http.post(api.info, params),
  getMemberChain: (params) => http.post(api.chain, params),
  getColumns: (params) => http.post(api.columns, params),
};
